export default __webpack_public_path__ + "static/media/profile_black.39cced99.png";